export const cache = <T>(fn: (...args: any[]) => T) => {
  let cache: Record<string | number, T> = {};
  return (...args: any): T => {
    let [n] = args;
    if (n in cache) {
      return cache[n];
    } else {
      let result = fn(n);
      cache[n] = result;
      return result;
    }
  }
};
